export default __webpack_public_path__ + "static/media/crypto.69e40dac.mp4";